"use client";
import { Search, X } from "lucide-react";
import { Input } from "@/app/components/shadcn/input";
import { Button } from "@/app/components/shadcn/button";

interface StoreSearchProps {
  storeName: string;
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const StoreSearch = ({ storeName, placeholder, value, onChange }: StoreSearchProps) => {
  return (
    <div className="relative">
      <Search
        size={16}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
      />
      <Input
        placeholder={placeholder ?? `${storeName}'da ara...`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-9 h-9 text-sm"
      />
      {value && (
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          onClick={() => onChange("")}
          className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full h-7 w-7"
        >
          <X size={14} />
        </Button>
      )}
    </div>
  );
};

export default StoreSearch;
